import Episode from "./components/Episodes";
import { Footer } from "./components/Footer";

function App(): JSX.Element {
  return (
    <>
      <Episode />
      <Footer />
    </>
  );
}

export default App;
